<template>
    <breeze-authenticated-layout>
        <template #header>
            <h2 class="font-semibold text-3xl text-gray-800 leading-tight py-2">
                T&C
            </h2>
        </template>
        <div class="p-6 bg-white border-b border-gray-200 shadow-sm sm:rounded-lg">
            <loading :showLoading="form.processing"/>
            <div :class="{'opacity-50':form.processing,'opacity-100':!form.processing}">
                <p class="text-lg font-medium mb-4">Add T&C</p>
                <form @submit.prevent="submitForm">
                    <div class="grid grid-cols-8 gap-4 mb-4">
                        <div class="col-span-8 sm:col-span-8">
                            <breeze-label :value="'Body'" :required="true" class="mb-1"/>
                            <vue-editor v-model="form.body"></vue-editor>
                            <breeze-input-error :message="form.errors?form.errors.body:''"/>
                        </div>
                        <div>
                            <breeze-label :value="'Branch'"/>
                            <input-checkbox required type="radio" class="rounded-full" name="type" v-model="form.type"
                                            value="branch" :checked="form.type == 'branch'"/>
                        </div>
                        <div>
                            <breeze-label :value="'Teacher'"/>
                            <input-checkbox required type="radio" class="rounded-full" name="type" v-model="form.type"
                                            value="teacher" :checked="form.type == 'teacher'"/>
                        </div>
                        <div>
                            <breeze-label :value="'Student'"/>
                            <input-checkbox required type="radio" class="rounded-full" name="type" v-model="form.type"
                                            value="student" :checked="form.type == 'student'"/>
                        </div>
                        <div class="col-span-2" v-if="form.type == 'branch'">

                            <FormMultiselect
                                label="Select Branch"
                                :options="branches"
                                track-key="id"
                                label-key="title"
                                :object="true"
                                v-model="form.branch"
                                :placeholder="'Select Branch'"
                                :error="form.errors.branch"
                            />
                        </div>
                    </div>
                    <button-link :href="route('term.index')" class="bg-red-500 mr-4 hover:bg-red-400">Cancel
                    </button-link>
                    <breeze-button :disabled="form.processing">Save</breeze-button>
                    <exception/>
                </form>
            </div>
        </div>
    </breeze-authenticated-layout>
</template>

<script>
import BreezeInput from '@/Components/Input'
import BreezeLabel from '@/Components/Label'
import BreezeCheckbox from '@/Components/Checkbox'
import InputCheckbox from '@/Components/InputCheckbox'
import SelectList from '@/Components/SelectList'
import BreezeButton from '@/Components/Button'
import BreezeInputError from '@/Components/InputError'
import ButtonLink from '@/Components/ButtonLink'
import Exception from '@/Components/Exception'
import {useForm} from '@inertiajs/inertia-vue3'
import Loading from '@/Components/Loading'
import {VueEditor} from "vue3-editor";
import FormMultiselect from "@/Components/Forms/FormMultiselect.vue";
import BreezeAuthenticatedLayout from '@/Layouts/Authenticated'

export default {
    components: {
        FormMultiselect,
        BreezeAuthenticatedLayout,
        ButtonLink,
        BreezeInput,
        BreezeLabel,
        BreezeInputError,
        BreezeButton,
        Exception,
        SelectList,
        Loading,
        BreezeCheckbox,
        InputCheckbox,
        VueEditor
    },
    props: ['branches'],
    data() {
        return {
            form: useForm({
                body: '',
                type: 'branch',
                branch: '',
            }),
        }
    },
    watch: {
        'form.type': function () {
            this.form.branch = '';
        }
    },
    methods: {
        submitForm() {
            this.form.post(route('term.store'), {
                preserveScroll: true,
                onSuccess: () => this.form.reset(),
            });
        },
    }
}
</script>
<style>
.ck-editor__editable {
    height: 400px;
}

.ck-file-dialog-button {
    display: none;
}
</style>
